import { v4 as uuidv4 } from 'uuid'

import FeedbackOne from 'assets/images/feedback/feedback2025/feedbackOne.png'
import FeedbackTwo from 'assets/images/feedback/feedback2025/feedbackTwo.png'
import FeedbackThree from 'assets/images/feedback/feedback2025/feedbackThree.png'
import FeedbackFour from 'assets/images/feedback/feedback2025/feedbackFour.png'
import FeedbackFive from 'assets/images/feedback/feedback2025/feedbackFive.png'
import FeedbackSix from 'assets/images/feedback/feedback2025/feedbackSix.png'
import FeedbackSeven from 'assets/images/feedback/feedback2025/feedbackSeven.png'
import FeedbackNine from 'assets/images/feedback/feedback2025/feedbackNine.png'
import FeedbackTen from 'assets/images/feedback/feedback2025/feedbackTen.png'
import FeedbackEleven from 'assets/images/feedback/feedback2025/feedbackEleven.png'
import FeedbackTwelve from 'assets/images/feedback/feedback2025/feedbackTwelve.png'
import FeedbackThirteen from 'assets/images/feedback/feedback2025/feedbackThirteen.png'
import FeedbackFourteen from 'assets/images/feedback/feedback2025/feedbackFourteen.png'
import FeedbackFifteen from 'assets/images/feedback/feedback2025/feedbackFifteen.png'
import FeedbackSixteen from 'assets/images/feedback/feedback2025/feedbackSixteen.png'
import FeedbackSeventeen from 'assets/images/feedback/feedback2025/feedbackSeventeen.png'
import FeedbackEighteen from 'assets/images/feedback/feedback2025/feedbackEighteen.png'
import FeedbackNineteen from 'assets/images/feedback/feedback2025/feedbackNineteen.png'
import FeedbackTwenty from 'assets/images/feedback/feedback2025/feedbackTwenty.png'
import FeedbackTwentyOne from 'assets/images/feedback/feedback2025/feedbackTwentyOne.png'
import FeedbackTwentyTwo from 'assets/images/feedback/feedback2025/feedbackTwentyTwo.png'
import FeedbackTwentyThree from 'assets/images/feedback/feedback2025/feedbackTwentyThree.png'
import FeedbackTwentyFour from 'assets/images/feedback/feedback2025/feedbackTwentyFour.png'
import FeedbackTwentyFive from 'assets/images/feedback/feedback2025/feedbackTwentyFive.png'
import FeedbackTwentySix from 'assets/images/feedback/feedback2025/feedbackTwentySix.png'
import FeedbackTwentySeven from 'assets/images/feedback/feedback2025/feedbackTwentySeven.png'
import FeedbackTwentyEight from 'assets/images/feedback/feedback2025/feedbackTwentyEight.png'
import FeedbackTwentyNine from 'assets/images/feedback/feedback2025/feedbackTwentyNine.png'
import FeedbackThirty from 'assets/images/feedback/feedback2025/feedbackThirty.png'

const feedbackData2025 = [
  {
    id: uuidv4(),
    image: FeedbackTwentyThree,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7335423994260574210/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackSix,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7332157943498293248/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackSeven,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7332469133676081152/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackEighteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7340287025415122945/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackNineteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7337182466803130369/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwenty,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7336759120005410816/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentyOne,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7336369407763394560/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentyTwo,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7335638959391158272/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentyFour,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7334214840749641729/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentySix,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7329906091855626240/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentySeven,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7330482033170771968/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentyEight,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7331314778616864772/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentyNine,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7331311996228771841/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackThirty,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7331288767690862594/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackOne,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7331952962384056321/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwo,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7332038648529354753/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackThree,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7332104105651228675/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFour,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7331967550571843584/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFive,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7332065207885692929/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackNine,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7332724058087755776/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7332738497113468929/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackEleven,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7333132586191323137/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwelve,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7333404164896477184/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackThirteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7333775361291325440/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFourteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7333818420758474754/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFifteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7334135120968249344/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackSixteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7333743348496646144/',
  },
  {
    id: uuidv4(),
    image: FeedbackSeventeen,
    link: 'https://www.linkedin.com/posts/innaozhogina_awscommunity-aws-awscommunityday-activity-7334148827454607360-3nLe?utm_source=share&utm_medium=member_desktop&rcm=ACoAAB_1naMBhGOOJyTQCpH16903paGhtiZZjSw',
  },
  {
    id: uuidv4(),
    image: FeedbackTwentyFive,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7334167337471770624/?actorCompanyId=93086989',
  },
]

export default feedbackData2025
